import React, { useImperativeHandle, forwardRef } from 'react';
import { useTranslation } from "react-i18next";
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { useErrorInputs } from '../../hooks/useErrorInputs';
import { MultipleSelect } from '../others/MultipleSelect';
import identificationTypes from "../../data/identificationTypes.json";
import taxResponsibilities from "../../data/taxResponsibilities.json";
import '../../styles/components/_forms.scss'

export const SupplierForm = forwardRef(({ dto, handleInputChange, handleDirectInputChange, isEdit }, ref) => {
    const fieldsRequired = ['supplier_id', 'supplier_tax_id', 'id_supplier_document', 'supplier', 'supplier_tax_scheme_id'];
    const [errorInputs, , , validForm] = useErrorInputs({});
    const { t } = useTranslation();
    useImperativeHandle(ref, () => ({
        getData: () => dto,
        errorInputs,
        validForm: () => validForm(fieldsRequired, dto)
    }));

    const handleChange = (e) => {
        const { name, value } = e.target;
        handleInputChange(name, value);
    };

    const handleSelectObligation = (event) => {
        const { target: { value }, } = event;
        handleDirectInputChange('supplier_tax_level_code', typeof value === 'string' ? value.split(',') : value);
    };

    return (
        <Box sx={{ mb: 2 }}>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <TextField fullWidth required disabled size="small" label={t('commonFields.nit')} name="supplier_id"
                        value={dto.supplier_id || ''}
                        // onChange={(e) => {
                        //     const { name, value } = e.target;
                        //     if (/^\d*$/.test(value)) {
                        //         // setEmisor((prev) => ({ ...prev, [name]: value }));
                        //         validField(name, value);
                        //     }
                        // }}
                        error={Boolean(errorInputs.supplier_id?.isError)}
                        helperText={errorInputs.supplier_id?.messageError || ''}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <TextField fullWidth disabled size="small" type='number' label={t('commonFields.verificationDigit')} name="supplier_digit" className='input-no-spinner'
                        value={dto.supplier_digit || ''}
                        // onChange={handleChange}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth required size="small"
                        error={Boolean(errorInputs.supplier_tax_id?.isError)}
                    >
                        <InputLabel>{t('commonFields.identificationType')}</InputLabel>
                        <Select disabled={isEdit} label={t('commonFields.identificationType')} name="supplier_tax_id"
                            value={dto.supplier_tax_id || ''}
                            onChange={handleChange}
                        >
                            {identificationTypes.map((option) => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
                        </Select>
                        {errorInputs.supplier_tax_id?.isError && <FormHelperText>{errorInputs.supplier_tax_id.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <FormControl fullWidth required size="small"
                        error={Boolean(errorInputs.id_supplier_document?.isError)}
                    >
                        <InputLabel>{t('commonFields.taxPayer')}</InputLabel>
                        <Select disabled={isEdit} label={t('commonFields.taxPayer')} name="id_supplier_document"
                            value={dto.id_supplier_document || ''}
                            onChange={handleChange}
                        >
                            <MenuItem value="1">{t('commonFields.legal')}</MenuItem>
                            <MenuItem value="2">{t('commonFields.natural')}</MenuItem>
                        </Select>
                        {errorInputs.id_supplier_document?.isError && <FormHelperText>{errorInputs.id_supplier_document.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <TextField fullWidth required disabled={isEdit} size="small" label={t('commonFields.businessName')} name="supplier"
                        value={dto?.supplier || ''}
                        onChange={handleChange}
                        error={!!errorInputs.supplier?.isError}
                        helperText={errorInputs.supplier?.messageError}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <FormControl required fullWidth size="small"
                        error={!!errorInputs.supplier_tax_scheme_id?.isError}
                    >
                        <InputLabel>{t('commonFields.taxType')}</InputLabel>
                        <Select disabled={isEdit} label={t('commonFields.taxType')} name="supplier_tax_scheme_id"
                            value={dto.supplier_tax_scheme_id || ''}
                            onChange={handleChange}
                        >
                            <MenuItem value="01">IVA</MenuItem>
                            <MenuItem value="04">INC</MenuItem>
                            <MenuItem value="ZA">IVA e INC</MenuItem>
                            <MenuItem value="ZZ">{t('commonFields.notApplicable')}</MenuItem>
                        </Select>
                        {errorInputs.supplier_tax_scheme_id?.isError && <FormHelperText>{errorInputs.supplier_tax_scheme_id.messageError}</FormHelperText>}
                    </FormControl>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <MultipleSelect
                        data={taxResponsibilities}
                        values={dto.supplier_tax_level_code}
                        handleChange={handleSelectObligation}
                        label={t('commonFields.obligations')}
                    />
                </Grid>
            </Grid>
        </Box>
    );
});
